import React from 'react';
import './FeatureCardLayout.css';

interface FeatureCardLayoutProps {
  title: string;
  description: string;
  previewContent: React.ReactNode;
  ctaContent?: React.ReactNode;
  className?: string;
}

const FeatureCardLayout: React.FC<FeatureCardLayoutProps> = ({
  title,
  description,
  previewContent,
  ctaContent,
  className,
}) => (
  <div className={`feature-card ${className || ''}`}>
    <div className="feature-card__preview">
      {previewContent}
    </div>
    <div className="feature-card__info">
      <h3 className="feature-card__title">{title}</h3>
      <p className="feature-card__description">{description}</p>
      {ctaContent && (
        <div className="feature-card__cta">
          {ctaContent}
        </div>
      )}
    </div>
  </div>
);

export default FeatureCardLayout;
